'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = require('eventemitter2');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _events = require('./events');

var events = _interopRequireWildcard(_events);

var _pluginError = require('./plugin-error');

var _pluginError2 = _interopRequireDefault(_pluginError);

var _merge = require('merge');

var _merge2 = _interopRequireDefault(_merge);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _defaults2 = require('./defaults');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Client = function () {
  function Client(defaults) {
    _classCallCheck(this, Client);

    var encodingIsInvalid = function encodingIsInvalid() {
      return defaults && typeof defaults.encoding !== 'undefined' && _defaults2.allowedEncodings.indexOf(defaults.encoding) === -1;
    };

    if (encodingIsInvalid()) {
      throw new Error(defaults.encoding + ' is not an allowed encoding value.');
    }

    this.defaults = _merge2.default.recursive(true, this._getDefaults(), defaults);

    if (this.defaults.url) {
      this.defaults.sep = this.defaults.url[this.defaults.url.length - 1] === '/' ? '' : '/';
    }

    this.eventEmitter = new _eventemitter2.default();
    this._plugins = [];
  }

  _createClass(Client, [{
    key: '_getDefaults',
    value: function _getDefaults() {
      return _defaults2.defaults;
    }
  }, {
    key: '_callPluginMethod',
    value: function _callPluginMethod(method, mutableArgIdx, earlyExit) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var i = 0;

      var shouldContinue = function shouldContinue() {
        return earlyExit ? args[mutableArgIdx] : true;
      };

      while (i < this._plugins.length && shouldContinue()) {
        if (this._plugins[i][method]) {
          var _plugins$i;

          args[mutableArgIdx] = (_plugins$i = this._plugins[i])[method].apply(_plugins$i, args);
        }
        i += 1;
      }

      return args[mutableArgIdx];
    }
  }, {
    key: '_callOnStarts',
    value: function _callOnStarts(request) {
      return this._callPluginMethod('onStart', 0, true, request);
    }
  }, {
    key: '_callOnSuccesses',
    value: function _callOnSuccesses(request, response) {
      return this._callPluginMethod('onSuccess', 1, false, request, response);
    }
  }, {
    key: '_callOnFails',
    value: function _callOnFails(request, response) {
      return this._callPluginMethod('onFail', 1, false, request, response);
    }
  }, {
    key: '_callOnErrors',
    value: function _callOnErrors(request, response) {
      return this._callPluginMethod('onError', 1, false, request, response);
    }
  }, {
    key: '_addHelpers',
    value: function _addHelpers(helpers) {
      var _this = this;

      if (helpers) {
        Object.keys(helpers).forEach(function (key) {
          _this[key] = helpers[key];
        });
      }
    }
  }, {
    key: '_getRequest',
    value: function _getRequest(path, options) {
      var fullPath = path;
      if (this.defaults && this.defaults.url) {
        fullPath = '' + this.defaults.url + this.defaults.sep + path;
      }

      return new Request(fullPath, options);
    }
  }, {
    key: 'fetch',
    value: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (path, options) {
      var _this2 = this;

      var request = void 0;
      var onStartError = void 0;

      if (path instanceof Request) {
        request = path;
      } else {
        request = this._getRequest(path, options);
      }

      this.eventEmitter.emit(events.REQUEST_START, request);
      try {
        request = this._callOnStarts(request);
      } catch (err) {
        onStartError = err;
      }

      var fetchPromise = void 0;
      if (request && !onStartError) {
        fetchPromise = fetch(request).then(function (response) {
          var mutatedResponse = void 0;
          if (response.status >= 400) {
            mutatedResponse = _this2._callOnFails(request, response);
            _this2.eventEmitter.emit(events.REQUEST_FAILURE, request, mutatedResponse);
          } else {
            mutatedResponse = _this2._callOnSuccesses(request, response);
            _this2.eventEmitter.emit(events.REQUEST_SUCCESS, request, mutatedResponse);
          }

          return mutatedResponse;
        }).catch(function (err) {
          var mutatedError = _this2._callOnErrors(request, err);
          _this2.eventEmitter.emit(events.REQUEST_ERROR, request, mutatedError);
          throw mutatedError;
        });
      } else {
        var err = onStartError || new _pluginError2.default();
        fetchPromise = Promise.reject(err);
      }

      return fetchPromise;
    })
  }, {
    key: 'addPlugin',
    value: function addPlugin(plugin) {
      plugin.client = this;
      this._plugins.push(plugin);
      this._addHelpers(plugin.helpers);
      if (plugin.onAddPlugin) {
        plugin.onAddPlugin(this);
      }
    }
  }, {
    key: 'removePlugin',
    value: function removePlugin(name) {
      var i = 0;
      for (i; i < this._plugins.length; i++) {
        if (this._plugins[i].name === name) {
          this._plugins.splice(i, 1);
          i -= 1;
        }
      }
    }
  }, {
    key: 'on',
    value: function on(event, cb) {
      this.eventEmitter.on(event, cb);
    }

    /* ---- HELPERS ---- */

  }, {
    key: '_formAppendArrayOrObject',
    value: function _formAppendArrayOrObject(formObject, data, key, forQueryString) {
      var _this3 = this;

      if (Array.isArray(data)) {
        data.forEach(function (val) {
          if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
            _this3._formAppendArrayOrObject(formObject, val, key + '[]');
          } else {
            if (!forQueryString || _this3.defaults.bracketStyleArrays) {
              formObject.append(key + '[]', val);
            } else {
              formObject.append('' + key, val);
            }
          }
        });
      } else {
        Object.keys(data).forEach(function (val) {
          if (_typeof(data[val]) === 'object') {
            _this3._formAppendArrayOrObject(formObject, data[val], key + '[' + val + ']');
          } else {
            formObject.append(key + '[' + val + ']', data[val]);
          }
        });
      }
    }
  }, {
    key: '_encodeForm',
    value: function _encodeForm(body, formObject, forQueryString) {
      var _this4 = this;

      Object.keys(body).forEach(function (val) {
        if (_typeof(body[val]) === 'object') {
          _this4._formAppendArrayOrObject(formObject, body[val], '' + val, forQueryString);
        } else {
          formObject.append(val, body[val]);
        }
      });

      return formObject;
    }
  }, {
    key: '_getEncodingTypeFromContentType',
    value: function _getEncodingTypeFromContentType(contentType) {
      var encodingType = false;
      if (contentType) {
        if (contentType.match(/text\/.+/i)) {
          encodingType = 'text';
        } else {
          switch (contentType) {
            case 'application/json':
              encodingType = 'json';
              break;
            case 'multipart/form-data':
              encodingType = 'form-data';
              break;
            case 'application/x-www-form-urlencoded':
              encodingType = 'x-www-form-urlencoded';
              break;
            default:
          }
        }
      }

      return encodingType;
    }
  }, {
    key: '_encode',
    value: function _encode(body, contentType) {
      var _body = body;
      var _contentType = contentType;

      var encodingType = this._getEncodingTypeFromContentType(_contentType);
      encodingType = encodingType || this.defaults.encoding;

      if (_body instanceof FormData || _body instanceof URLSearchParams) {
        return { body: _body, contentType: false };
      }

      var formObject = void 0;
      switch (encodingType) {
        case 'json':
          _body = JSON.stringify(_body);
          _contentType = 'application/json';
          break;
        case 'text':
          _contentType = _contentType || 'text/plain';
          break;
        case 'form-data':
          formObject = new FormData();
          _body = this._encodeForm(_body, formObject);
          _contentType = undefined;
          break;
        case 'x-www-form-urlencoded':
          formObject = new URLSearchParams();
          _body = this._encodeForm(_body, formObject);
          _contentType = undefined;
          break;
        default:
      }

      return { body: _body, contentType: _contentType };
    }
  }, {
    key: '_buildOptionsWithBody',
    value: function _buildOptionsWithBody(method, body, options) {
      var _options = _extends({}, this.defaults[method]);
      _options = _merge2.default.recursive(true, _options, options);

      var _encode2 = this._encode(body, _options.headers['Content-Type']),
          encodedBody = _encode2.body,
          contentType = _encode2.contentType;

      if (contentType === false) {
        delete _options.headers['Content-Type'];
      } else {
        _options.headers['Content-Type'] = contentType;
      }

      _options.body = encodedBody;
      return _options;
    }
  }, {
    key: 'get',
    value: function get(path, body, options) {
      var _options = options || {};
      var queryString = '';

      _options.headers = (0, _merge2.default)(true, (0, _lodash2.default)(this.defaults, 'get.headers'));

      if (body && Object.keys(body).length) {
        queryString = this.defaults.queryStringifier.bind(this)(body);
      }

      _options.method = 'GET';
      return this.fetch(path + queryString, _options);
    }
  }, {
    key: 'post',
    value: function post(path, body, options) {
      var _options = this._buildOptionsWithBody('post', body, options);
      _options.method = 'POST';
      return this.fetch(path, _options);
    }
  }, {
    key: 'put',
    value: function put(path, body, options) {
      var _options = this._buildOptionsWithBody('put', body, options);
      _options.method = 'PUT';
      return this.fetch(path, _options);
    }
  }, {
    key: 'patch',
    value: function patch(path, body, options) {
      var _options = this._buildOptionsWithBody('patch', body, options);
      _options.method = 'PATCH';
      return this.fetch(path, _options);
    }
  }, {
    key: 'delete',
    value: function _delete(path, options) {
      var _options = options || {};
      _options.method = 'DELETE';
      return this.fetch(path, _options);
    }
  }]);

  return Client;
}();

exports.default = Client;


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/client.js
// module id = 734
// module chunks = 0